<template>
  <v-dialog v-model="dialogSearch" max-width="1000px">
    <v-btn
      :ripple="false"
      slot="activator"
      class="btn--plain ma-0 pa-0"
      flat
    >
      <v-icon>add</v-icon>New {{formatName(this.field.name)}}
    </v-btn>
    <v-card class="pa-4">
      <v-card-title class="pa-0 pb-4">
        <h1>New {{formatName(this.field.name)}}</h1>
      </v-card-title>
      <v-layout row wrap>
        <v-flex sm12 md12 px-0 class="no-jump-to-column">
          <FieldsetContainer2
            id="case-data-all"
            :caseData="currentCase"
            v-on:fieldset-list-updated="fieldsetListUpdated"
            v-on:save="save()"
            :caseType="caseType"
            new-case
            relation-field-mode
            >
          </FieldsetContainer2>
        </v-flex>
      </v-layout>
      <v-card-actions class="ma-0 mt-0 pa-0">
        <v-btn @click.stop="cancelCase()" color="secondary">Cancel</v-btn>
        <v-btn @click.stop="saveCase()" color="primary" class="success">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Helpers from "@/helpers.js";

export default {
  name: 'RelationFieldAddCaseDialog',
  methods: {
    formatName(name) {
      return Helpers.capitalizeRemoveUnderscores(name);
    },
    fieldsetListUpdated() {
    },
    cancelCase() {
      this.dialogSearch = false
      this.currentCase = {properties: {}, title: ""}
    },
    async saveCase() {
      this.dialogSearch = false
      console.log({currentCase: this.currentCase});
      const response = await this.$store.dispatch("createRelatedCase", { caseTypeCode: this.caseType.code, properties: this.currentCase.properties })
      const newCaseId = response.caseData.id
      console.log({newCaseId})
      this.$emit('set-related-case', newCaseId)
    }
  },
  components: {
    FieldsetContainer2: () => import("@/components/cases/case-edit/FieldsetContainer2.vue"),
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    caseType: {
      type: Object,
      required: true
    },
  },
  computed: {   
    fields() {
      if (this.caseType && this.caseType.displayFields) {
        return this.caseType.displayFields;
      } else {
        return [];
      }
    },    
    keys() {
      return this.fields.map((field) => field.fieldName);
    }
  },
  mounted() {
    this.currentCase = {properties: {}, title: ""}
  },
  data: () => {
    return {
      currentCase: {properties: {}, title: ""},
      tableHeaders: [],
      tableItems: [],
      dialogNew: false,
      dialogSearch: false,
      searchObj: {},
      quickSearchData: "",
      quickSearchCases: [],
      quickSearchSelection: {},
      summary: {},
    };
  },  
}
</script>